import template from './content-toggler.html';

const DIRECTIVE_NAME = ContentToggler.DIRECTIVE_NAME = 'ktContentToggler';
export default function ContentToggler() {
    return {
        restrict: 'A',
        controller: ContentTogglerController,
        controllerAs: 'contentTogglerCtrl',
        template,
        bindToController: true,
        transclude: true,
        scope: {
            heading: `@${DIRECTIVE_NAME}Heading`,
            isOpen: `=${DIRECTIVE_NAME}IsOpen`,
        },
        link,
    };

    function link($scope, $elem, $attrs, contentToggleCtrl) {
        contentToggleCtrl.$onInit();
    }
}

export function ContentTogglerController(
    rangeSliderService
) {
    'ngInject';

    const vm = this;
    const DEFAULT_VISIBILITY = false;
    Object.assign(vm, {
        $onInit,
        toggleControl,
        forceRenderSlider: rangeSliderService.forceRenderSlider,
    });

    function $onInit() {
        vm.isVisible = vm.isOpen || DEFAULT_VISIBILITY;
    }

    function toggleControl() {
        vm.isVisible = !vm.isVisible;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/common/widgets/content-toggler/content-toggler-component.js